/**
 * Equipment — `docs/visit-page.md` §10 (Board 5 A the tab, B the unit picker)
 * and §27.5 (Board 18 G *no units yet*, H *Add a unit*).
 *
 * Equipment is planned by type; a unit is picked for each day — here, or left
 * to morning assignment (*Decide in the morning*, do-not-substitute 8). What
 * the company rents in is **Rented from a vendor** (`rentals.ts`).
 */
import { z } from 'zod';
// ---------------------------------------------------------------------------
// Writes
// ---------------------------------------------------------------------------
/**
 * `PUT /visits/:id/days/:n/equipment/:typeId` — `{equipmentId} |
 * {decideInTheMorning:true}` (§5.2), through `EquipmentPort.holdUnit`. The
 * exclusion constraint guards double-booking (`resource_conflict`).
 */
export const holdUnitSchema = z.union([
    z.object({ equipmentId: z.string().uuid() }),
    z.object({ decideInTheMorning: z.literal(true) }),
]);
/** `POST /visits/:id/equipment` — **Add equipment** (Board 5): *Type*, the days (chips), hours per day. */
export const addEquipmentSchema = z.object({
    typeId: z.string().uuid(),
    days: z.array(z.object({
        day: z.number().int().min(1).max(366),
        hours: z.number().positive().max(24),
    })).min(1, 'Pick a day.'),
});
/**
 * `POST /visits/:id/equipment-units` — **Add a unit** (Board 18 H, §27.5):
 * an `equipment` row (`added_from = 'visit'`) of the type, through
 * `EquipmentPort.addUnit`. **Add MSS-03**.
 */
export const addUnitSchema = z.object({
    /** **Type** (filled). */
    typeId: z.string().uuid(),
    /** **Unit number** (required) — *MSS-03*. */
    unitNumber: z.string().trim().min(1, 'Give it a unit number.').max(40),
    /** **Lives at** — *Harrisburg yard*. */
    yardId: z.string().uuid().nullish(),
    /**
     * **Cost per hour** — *internal · used for the visit's cost* (`internal_hourly_rate`).
     * Left out by a person without *Costs & margins*, who is never shown it
     * (§2.3): the unit then takes the quote's rate for its type.
     */
    ratePerHour: z.string().trim().regex(/^\d+(\.\d{1,2})?$/, 'A rate, like 32.00.').optional(),
});
// ---------------------------------------------------------------------------
// What the two popups open with
// ---------------------------------------------------------------------------
/** `GET /visits/:id/equipment-units/options?typeId=` — **Add a unit** (Board 18 H). */
export const addUnitOptionsQuerySchema = z.object({ typeId: z.string().uuid() });
//# sourceMappingURL=equipment.js.map